import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios';
import VueElementLoading from "vue-element-loading";
import 'leaflet/dist/leaflet.css';
import * as VueGoogleMaps from 'vue2-google-maps';
import { VueMaskDirective } from 'v-mask';
Vue.directive('mask', VueMaskDirective);

import RedirectPlugin from '@/plugins/redirectPlugin';
Vue.use(RedirectPlugin);

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VueMeta from 'vue-meta';

Vue.use(Toast);
Vue.use(VueMeta);

// Import Firebase SDK
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC38J2_6fjayeMGpfPfafSvzaxIgK6LMII",
  authDomain: "teamite-7792b.firebaseapp.com",
  projectId: "teamite-7792b",
  storageBucket: "teamite-7792b.appspot.com",
  messagingSenderId: "499870334846",
  appId: "1:499870334846:web:b8930a50ca43542e1e7d2f",
  measurementId: "G-1CME4RDV97",
  clientId: 'com.leopardtechlabs.teamite',
  redirectURI: 'https://teamite-7792b.firebaseapp.com/__/auth/handler',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider('apple.com');

// appleProvider.setCustomParameters({
//   redirect_uri: firebaseConfig.redirectURI,
// });

export { auth, googleProvider, appleProvider };


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC8hzKf4_zFPQJxRzpoNe8-mcWpd4QZlB4', // replace with your actual Google Maps API key
    libraries: 'places',
  },
  installComponents: true // automatically install components
});



Vue.config.productionTip = false
Vue.component("VueElementLoading", VueElementLoading);


window.axios = require('axios')
axios.defaults.baseURL = 'https://api.teamite.app/';
Vue.prototype.baseURL = "https://api.teamite.app/" 
Vue.prototype.mediaURL = "https://api.teamite.app/file/get/"
Vue.prototype.mediaURLnewx = "https://api.teamite.app/u/"



// window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.49.88:5050'
// Vue.prototype.baseURL = "http://192.168.49.88:5050"
// Vue.prototype.mediaURL = "http://192.168.49.88:5050/file/get/"
// Vue.prototype.mediaURLnew = "http://192.168.49.88:5050/wp"

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://localhost:5050'
// Vue.prototype.baseURL = "http://localhost:5050"
// Vue.prototype.mediaURL = "http://localhost:5050/file/get/"
// Vue.prototype.mediaURLnew = "http://localhost:5050/wp/"

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  mounted() {
    this.$router.afterEach((to) => { 
      if (typeof window !== 'undefined' && window.gtag) {  
        window.gtag('config', 'G-MDJ18FHLB6', {  
          page_path: to.fullPath,
        });
      }
    });
  },
}).$mount('#app')

 